export enum TwoFactorAuthMode {
    None = "None",
    GoogleAuthenticator = "GoogleAuthenticator",
}
